import React from 'react'
import { createRoot } from 'react-dom/client'
import TeamPublicPageApp from '../components/TeamPublicPage/TeamPublicPageApp'
import ReviewPromptCard from 'components/Student/ReviewPromptCard'
import { showActivityNotifications } from 'utils/socialProofToast'
import { startTeamPageTracking } from 'utils/teamPageTracking'

const VISITOR_TOKEN_KEY = 'tn_visitor_token'

function backupVisitorToken() {
  const cookie = document.cookie.split('; ')
    .find(c => c.startsWith('team_visitor_token='))
  if (cookie) {
    const token = cookie.split('=')[1]
    localStorage.setItem(VISITOR_TOKEN_KEY, token)
  }
}

function restoreVisitorToken() {
  const hasCookie = document.cookie.includes('team_visitor_token=')
  if (!hasCookie) {
    const saved = localStorage.getItem(VISITOR_TOKEN_KEY)
    if (saved) {
      const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString()
      document.cookie = `team_visitor_token=${saved}; expires=${expires}; path=/`
    }
  }
}

// Restore before server request on next navigation
restoreVisitorToken()

document.addEventListener('DOMContentLoaded', () => {
  // Backup after server has set the cookie
  backupVisitorToken()

  // Review prompt. Its own mount point, rendered by the server above the React
  // container, so the shared card reaches this page without TeamPublicPageApp
  // knowing about it.
  const reviewContainer = document.getElementById('team-review-prompt-card')
  if (reviewContainer) {
    let teachers = []
    let reviewTranslations = {}
    try {
      teachers = JSON.parse(reviewContainer.dataset.teachers || '[]')
      reviewTranslations = JSON.parse(reviewContainer.dataset.translations || '{}')
    } catch (e) {
      console.error('Failed to parse review prompt data:', e)
    }
    if (teachers.length > 0) {
      createRoot(reviewContainer).render(
        <ReviewPromptCard
          teachers={teachers}
          translations={reviewTranslations}
          highlight={reviewContainer.dataset.highlight === 'true'}
          showTeamName={false}
        />
      )
    }
  }

  const container = document.getElementById('team-public-page')
  if (container) {
    const initialData = JSON.parse(container.dataset.teamData)
    const teamSlug = container.dataset.teamSlug

    // Before render, so events sent from mount effects carry flow_id too.
    startTeamPageTracking(initialData)

    // Activity notifications from server
    showActivityNotifications(initialData.recentActivity)

    const root = createRoot(container)
    root.render(
      <TeamPublicPageApp
        initialData={initialData}
        teamSlug={teamSlug}
      />
    )
  }
})
